export const setUserInfo = (data) => {
  return {
    type: 'SET_INFO',
    payload: data
  };
};
